import React from "react";
import { useSelector } from "react-redux";
import { Table, Tabs } from "antd";
import { ColorfulTag } from "components";
import { CardChart } from "components";
import { PieChart, Pie, Legend, Cell } from "recharts";
import { colors } from "utils/config";
import { Link } from "react-router-dom";
import { sortStrings, withNumberingColumn } from "utils/utils";

const TeacherStudents = () => {
  const schoolId = useSelector((state) => state?.user?.selectedSchool?.id);
  const teacherStudents = useSelector((state) => state.teachersProfile && state.teachersProfile.teacherStudents);
  const teacherStudentsMapped = teacherStudents?.map((student, index) => {
    return {
      order: index,
      title: student.contractStudentFullName,
      status: student.contractStatus,
      instrument: student.instruments,
      tarif: student.contractTarif,
      id: student.contractStudentId,
      key: index,
    };
  });

  const getCalculatedStudents = (data) => {
    let total = 0;
    data.map((studentStatus) => {
      total += studentStatus.value;
    });
    return total;
  };

  const teacherStudentsCol = [
    {
      title: "Student Name",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => sortStrings(a, b, "title"),
      render: (title, { id }) => {
        return <Link to={`/dashboard/${schoolId}/profile/${id}`}>{title}</Link>;
      },
    },

    {
      title: "Tarif",
      dataIndex: "tarif",
      key: "tarif",
      sorter: (a, b) => sortStrings(a, b, "tarif"),
      render: (tarif) => <span>{tarif}</span>,
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => sortStrings(a, b, "status"),
      render: (status) => (
        <span>
          <ColorfulTag text={status} />
        </span>
      ),
    },
    {
      title: "Instrument",
      dataIndex: "instrument",
      key: "instrument",
      sorter: (a, b) => sortStrings(a, b, "instrument"),
      render: (instrument) => <span>{instrument}</span>,
    },
  ];
  const pieDataActive = [];
  const statusDataActive = [];
  const pieDataFormer = [];
  const statusDataFormer = [];
  teacherStudentsMapped &&
    teacherStudentsMapped.reduce(function (res, value) {
      // Group NO BILL with VOUCHER status
      const statusKey = value.status === "NO BILL" ? "VOUCHER" : value.status;

      if (!res[statusKey]) {
        res[statusKey] = { name: statusKey, value: 0 };
        if (statusKey !== "CANCELED") {
          pieDataActive.push(res[statusKey]);
          statusDataActive.push(res[statusKey]);
        }
        if (statusKey === "CANCELED") {
          pieDataFormer.push(res[statusKey]);
          statusDataFormer.push(res[statusKey]);
        }
      }
      res[statusKey].value++;

      return res;
    }, {});

  return (
    <>
      <Tabs
        className={"teacherTabs"}
        defaultActiveKey="1"
        type={"card"}
        items={[
          {
            key: "1",
            label: "Active",
            children: (
              <>
                <CardChart
                  cardHeight={"300px"}
                  chartHeight={"250px"}
                  chart={
                    <PieChart>
                      <Pie dataKey="value" data={pieDataActive} innerRadius={40} outerRadius={70} paddingAngle={5}>
                        {" "}
                        {pieDataActive?.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={colors[index]} />
                        ))}
                      </Pie>
                      <Legend />
                    </PieChart>
                  }
                />

                <div className={"stats"}>
                  {statusDataActive?.map(({ name, value }) => {
                    return name !== "CANCELED" ? (
                      <div key={name} className={"stats__item"}>
                        {" "}
                        <span className={"stats__item__title"}>
                          <span className={"stats__item__title__number"}> {value} </span>
                          {name.toLowerCase()} Students{" "}
                        </span>{" "}
                        <span className={"stats__item__percentage"}>{`${(
                          (value / getCalculatedStudents(statusDataActive)) *
                          100
                        ).toFixed(1)} %`}</span>
                      </div>
                    ) : null;
                  })}
                </div>

                <div className={"stats"}></div>
                <Table
                  rowKey="key"
                  columns={withNumberingColumn(teacherStudentsCol)}
                  dataSource={teacherStudentsMapped.filter((i) => i.status !== "CANCELED")}
                  pagination={false}
                />
              </>
            ),
          },
          {
            key: "2",
            label: "Former",
            children: (
              <>
                <CardChart
                  cardHeight={"300px"}
                  chartHeight={"250px"}
                  chart={
                    <PieChart>
                      <Pie dataKey="value" data={pieDataFormer} innerRadius={40} outerRadius={70} paddingAngle={5}>
                        {" "}
                        {pieDataFormer?.map((entry, index) => (
                          <Cell key={`cell-${index}`} fill={colors[index]} />
                        ))}
                      </Pie>
                      <Legend />
                    </PieChart>
                  }
                />

                <div className={"stats"}>
                  {statusDataFormer?.map(({ name, value }) => {
                    return name === "CANCELED" ? (
                      <div key={name} className={"stats__item"}>
                        {" "}
                        <span className={"stats__item__title"}>
                          <span className={"stats__item__title__number"}> {value} </span>
                          {name.toLowerCase()} Students{" "}
                        </span>{" "}
                        <span className={"stats__item__percentage"}>{`${(
                          (value / getCalculatedStudents(statusDataFormer)) *
                          100
                        ).toFixed(1)} %`}</span>
                      </div>
                    ) : null;
                  })}
                </div>

                <div className={"stats"}></div>
                <Table
                  rowKey="key"
                  columns={withNumberingColumn(teacherStudentsCol)}
                  dataSource={teacherStudentsMapped.filter((i) => i.status === "CANCELED")}
                  pagination={false}
                />
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default TeacherStudents;
